export default "__VITE_ASSET__CO0zBFmE__"